import { lazy } from "react";

const ChecklistPage = lazy(
  () => import("../../../features/checklist/ChecklistPage")
);
const VisualizarChecklist = lazy(
  () => import("../../../features/checklist/ChecklistViewPage")
);

export const checklistRoutes = [
  {
    path: "/checklist/:checklistId/:vehicleId",
    component: ChecklistPage,
    private: true,
  },
  {
    path: "/VisualizarChecklist/:checklistRespondidoId",
    component: VisualizarChecklist,
    private: true,
  },
];
